/*=========================================================================================
  File Name: store.js
  Description: Vuex store
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import Vuex from 'vuex'

import state from "./state"
import getters from "./getters"
import mutations from "./mutations"
import actions from "./actions"

Vue.use(Vuex)
import moduleAuth from './auth/moduleAuth.js'
import moduleTimekeeping from './timekeeping/moduleTimekeeping.js'
// import moduleLeaveManagement from './leavemanagement/moduleLeaveManagement.js'
import moduleOvertime from './overtime/moduleOvertime.js'
// import moduleLoans from './loans/moduleLoans.js'
// import moduleClaims from './claims/moduleClaims.js'
import moduleTenants from './tenants/moduleTenants.js'
import moduleHRMS from './hrms/moduleHRMS.js'
import moduleLookup from './lookup/moduleLookup.js'



import modulePayroll from './payroll/modulePayroll.js'
import moduleCreateSchedule from './createschedule/moduleCreateSchedule'


// import moduleCalendar from './calendar/moduleCalendar.js'


export default new Vuex.Store({
    getters,
    mutations,
    state,
    actions,
    modules: {
      // todo: moduleTodo,
      // calendar: moduleCalendar,
      // chat: moduleChat,
      // email: moduleEmail,
      auth: moduleAuth,
      timekeeping: moduleTimekeeping,
      // leavemanagement: moduleLeaveManagement,
      overtime: moduleOvertime,
      // loans: moduleLoans,
      // claims: moduleClaims,
      tenants: moduleTenants,
      hrms : moduleHRMS,
      lookup : moduleLookup,
      payroll : modulePayroll,
      schedule: moduleCreateSchedule
    },
    strict: process.env.NODE_ENV !== 'production'
})
